import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { StartupService } from '../../common/services/startup.service';
import { AdobeAnalyticsService } from './adobe-analytics.service';
import { constants } from '../../configs/config-internal-constants';

@Injectable()
export class AdobeAnalyticsScriptService {
  private scriptConf: any;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private startup: StartupService,
    private adobeAnalyticsService: AdobeAnalyticsService
  ) {
    this.setData();
  }

  private setData() {
    this.scriptConf = {
      loaded: false,
      src: '',
      id: constants.ADOBE,
    };

    if (this.startup.adobeTrackingURL != null) {
      this.scriptConf.src = this.startup.adobeTrackingURL;
    }

    this.adobeAnalyticsService.digitalData = {
      page: {
        pageInfo: {
          applicationID: 'CONTACT_US',
          channel: 'olb',
          segment: '',
          productIdentifier: '',
          pageIdentifier: '',
          subsection1: '',
          subsection2: 'help-and-contact-us',
          subsection3: 'contact-us',
          subsection4: '',
          errorMsg: {},
        },
      },
      errorCode: '',
      errorDescription: '',
    };
  }

  initialize(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.loadHeader()
        .then((response) => {
          (window as any)._satellite.pageBottom();

          resolve('satellite has been applied');
        })
        .catch((error) => {
          reject('satellite has not been applied');
        });
    });
  }

  public loadHeader(): Promise<string> {
    return new Promise((resolve, reject) => {
      if (this.scriptConf.loaded) {
        resolve('already loaded');
      } else {
        const script = this.document.createElement('script');
        script.src = this.scriptConf.src;

        if (script.readyState) {
          script.onreadystatechange = () => {
            if (
              script.readyState === 'loaded' ||
              script.readyState === 'complete'
            ) {
              script.onreadystatechange = null;
              this.scriptConf.loaded = true;
              resolve('loaded');
            }
          };
        } else {
          script.onload = () => {
            this.scriptConf.loaded = true;
            resolve('loaded');
          };
        }
        script.onerror = (error: any) => {
          this.scriptConf.loaded = false;
          reject('not loaded');
        };
        this.document.getElementsByTagName('head')[0].appendChild(script);
      }
    });
  }
}
